import { useEffect, useState } from "react";

import { db } from "../firebase/config";
import getTime from "../helpers/getTime";
import { sortBy } from "lodash";
import useEvent from "./useEvent";

export interface SpeakerProps {
  title?: string;
  firstname: string;
  lastname: string;
  position?: string;
  institute?: string;
  city?: string;
  country?: string;
  bio?: string;
  image?: string;
  cover?: string;
  link: string;
}

export interface ViewerProps {
  ID: string;
  email: string;
  title?: string;
  firstname?: string;
  lastname?: string;
  position?: string;
  institute?: string;
  city?: string;
  country?: string;
  bio?: string;
  image?: string;
  cover?: string;
}

export interface SessionProps {
  ID: string;
  title: string;
  description?: string;
  src?: string;
  timeStart: Date;
  timeEnd: Date;
  room: number;
  speaker?: SpeakerProps;
  viewers?: ViewerProps[];
}

const useSessions = () => {
  const event = useEvent();
  const [sessions, setSessions] = useState<SessionProps[]>();

  useEffect(() => {
    const getSpeaker = async (speakerID: string) => {
      const speakerRef = await db.collection("speakers").doc(speakerID).get();
      const speakerData = speakerRef.data();
      return speakerData;
    };

    const getViewer = async (viewerID: string) => {
      const viewerRef = await db.collection("profiles").doc(viewerID).get();
      const viewerData = viewerRef.data();
      return viewerData;
    };

    const fetch = async () => {
      const sessionsRef = await db.collection("sessions").get();
      const sessions = await Promise.all(
        sessionsRef.docs.map(async (doc) => {
          const sessionData = doc.data();
          const { timeStart, timeEnd, speaker, viewers } = sessionData;

          return {
            ...sessionData,
            ID: doc.id,
            timeStart: timeStart?.toDate(),
            timeEnd: timeEnd?.toDate(),
            speaker: speaker ? await getSpeaker(speaker.id) : undefined,
            viewers: viewers
              ? await Promise.all(
                  viewers.map(async (viewer: { id: string }) => {
                    const viewerData = await getViewer(viewer.id);

                    return {
                      ...viewerData,
                      ID: viewer.id,
                    };
                  })
                )
              : undefined,
          };
        })
      );

      return setSessions(
        sortBy(sessions, ["timeStart"])
          .filter((session: any) => {
            if (event === "SEAADE-IADR") {
              return true;
            }

            if (
              event === "SEAADE" &&
              session.timeStart < getTime("26 Nov 2020")
            ) {
              return true;
            }

            if (
              event === "IADR" &&
              session.timeStart > getTime("26 Nov 2020")
            ) {
              return true;
            }

            return false;
          })
          .map((session: any) => {
            return session;
          })
      );
    };

    fetch();
  }, [event]);

  return sessions;
};

export default useSessions;
